<template>
  <div class="app-message-center" aria-live="polite" aria-relevant="additions">
    <transition-group name="app-message" tag="div" class="app-message-stack">
      <div v-for="item in state.items" :key="item.id" class="app-message" :class="'is-' + item.type" :role="item.type === 'error' ? 'alert' : 'status'">
        <span class="app-message-icon" aria-hidden="true">
          <svg v-if="item.type === 'success'" viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7" /></svg>
          <svg v-else-if="item.type === 'error'" viewBox="0 0 24 24"><path d="M7 7l10 10M17 7 7 17" /></svg>
          <svg v-else viewBox="0 0 24 24"><path d="M12 6v7m0 4h.01" /></svg>
        </span>
        <span class="app-message-text">{{ item.text }}</span>
        <button type="button" class="app-message-close" aria-label="关闭消息" @click="remove(item.id)">×</button>
      </div>
    </transition-group>
  </div>
</template>

<script>
import message from '../services/message'
export default { name: 'MessageCenter', data () { return { state: message.state } }, methods: { remove: message.remove } }
</script>
